export default __webpack_public_path__ + "static/media/modal_bottom_small.d491b0b0.png";